function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "24",
  viewBox: "0 0 18 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.875 6H13.5V4.8C13.5 2.149 11.485 0 9 0S4.5 2.149 4.5 4.8V6H1.125C.504 6 0 6.537 0 7.2v13.2C0 22.388 1.511 24 3.375 24h11.25C16.489 24 18 22.388 18 20.4V7.2c0-.663-.504-1.2-1.125-1.2zM6.75 4.8c0-1.325 1.007-2.4 2.25-2.4s2.25 1.075 2.25 2.4V6h-4.5V4.8zm9 15.6c0 .663-.504 1.2-1.125 1.2H3.375c-.621 0-1.125-.537-1.125-1.2v-12H4.5v1.2c0 .663.504 1.2 1.125 1.2s1.125-.537 1.125-1.2V8.4h4.5v1.2c0 .663.504 1.2 1.125 1.2s1.125-.537 1.125-1.2V8.4h2.25v12z",
  fill: "currentColor",
  fillRule: "evenodd"
})));